class CheckSectionMustBeExpanded {
  execute({
    postId,
    sections
  }) {
    let id = '';
    sections.forEach(section => {
      const post = section.posts.some(post => post.id === postId);
      if (post) {
        id = section.id;
      }
    });
    return id;
  }
}

export { CheckSectionMustBeExpanded };
